import { EmptyState } from "@/components/shared";
import { ShowingCard } from "@/pages/showings/ShowingCard";
import { CalendarCheck } from "lucide-react";

export const RenterShowingsTab = ({ showings, respondShowing }) => {
  if (showings.length === 0) {
    return (
      <div className="bg-white border border-line rounded-xl"><EmptyState icon={CalendarCheck} title="No showings scheduled" /></div>
    );
  }
  return (
    <div className="space-y-3">
      {showings.map((s) => (
        <ShowingCard key={s.id} showing={s} role="renter" respond={respondShowing} />
      ))}
    </div>
  );
};
